import { Box, styled } from '@ethings/ui-toolkit';
import { useTheme } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useAuth, useAuthenticated } from '../../auth';
import { Avatar } from '../avatar';
import { FILTERS_KEY } from '../filter';
import { useBoolFlag } from '../flags';
import { Icon } from '../icons';
import { SideMenuBox } from './side-menu-box';
import { sideMenuTransitionStyles } from './side-menu.utils';

interface SideMenuProfileProps extends PropsWithChildren {
  isOpen: boolean;
}

export const SideMenuProfile: FC<SideMenuProfileProps> = ({ isOpen, children }) => {
  const theme = useTheme();
  const hasProfileFeature = useBoolFlag('portals-profile-feature');
  const { switchAccount } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation(['common']);
  const { account, user } = useAuthenticated();

  return (
    <SideMenuBox data-testid="profile-section" id="profile">
      <StyledBox pl={isOpen ? 1 : 0}>
        <Avatar
          background={theme.sidebar.avatar.background}
          chevronIcon={<Icon icon="ChevronDown" fontSize="small" />}
          displayAccountSwitcher
          iconColor={theme.sidebar.avatar.iconColor}
          muiAvatarSx={{ transform: `scale(0.65) translateX(${theme.spacing(1)})`, transformOrigin: 'left center', width: 42, height: 42, ...sideMenuTransitionStyles }}
          handleNavigate={() => hasProfileFeature ? navigate('/profile') : null}
          onSelected={async (value: string) => {
            await switchAccount(value);
            localStorage.setItem(FILTERS_KEY, JSON.stringify([]));
          }}
          showIconOnly={!isOpen}
          spacing={0}
          subtitle={account.display}
          title={user.display}
          tooltip={hasProfileFeature ? t('common:page.profile.title') : ''}
        />
      </StyledBox>
      {children}
    </SideMenuBox>
  );
};

const StyledBox = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  ...sideMenuTransitionStyles,
}));
